import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/TopCompanyEntitySlice';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.topEntities || initialState;
export const selectLoading = createSelector([selectDomain], (state) => state.entitiesLoading);
export const selectedCompanies = createSelector([selectDomain], (state) => state.companies);
export const selectEntitiesLoading = createSelector(
  [selectDomain],
  (state) => state.entitiesLoading,
);
export const selectCompanyExecutives = createSelector(
  [selectDomain],
  (state) => state.companyExecutives,
);
export const selectCompanyCompetitorsExecutives = createSelector(
  [selectDomain],
  (state) => state.companyCompetitorsExecutives,
);
export const selectCompanyCompetitors = createSelector(
  [selectDomain],
  (state) => state.companyCompetitors,
);
export const selectExecutives = createSelector([selectDomain], (state) => state.executives);
